import { useParams } from 'react-router-dom'
import './RequestConfirm.css'

const RequestConfirm = () => {
    const { id } = useParams()
    return (
        <div className="request-confirm-page">
            <div className="request-confirm-container">
                <h2 className="request-confirm-title">Confirmar Solicitud #{id}</h2>
                <div className="request-confirm-message">Página en construcción</div>
            </div>
        </div>
    )
}

export default RequestConfirm


